<div class="col full-height layout-column"
     (mouseenter)="onHover(true)"
     (mouseleave)="onHover(false)"
     (click)="onSelect.emit($event)">

  <div class="flex layout-row layout-wrap overflow-auto">

    <!--Link Row-->
    <div *ngIf="settings?.columns?.id" class="flex-100 layout-row layout-align-start-center">
      <app-bringoz-state-link *ngIf="job?.fulfillmentId && activity.type !== 'GROUP'"
                              class="text-ellipsis"
                              [state]="'fulfillment'"
                              [params]="{id : job?.fulfillmentId}"
                              [text]="job?.fulfillmentId">
      </app-bringoz-state-link>

      <bringoz-button *ngIf="job && activity.type !== 'GROUP'"
                      type="tertiary"
                      size="fit"
                      [ngbTooltip]="'View Job Details' | translate"
                      openDelay="300"
                      (onClick)="onViewJob.emit({jobs: [job], event: $event})">
        <bringoz-icon iconName="info-outline" classSize="lg" fill="#484848"></bringoz-icon>
      </bringoz-button>
    </div>

    <!--Start/End Row-->
    <div *ngIf="(activity.type === 'START') || (activity.type === 'END')"
         class="flex-100 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="location-pin-outline"
                    classSize="lg"
                    fill="#484848">

      </bringoz-icon>
      <span class="br-body-1">{{ 'STOP_PURPOSE.' + activity.type | translate }}</span>
    </div>

    <!--Account Row-->
    <div *ngIf="settings?.columns?.account && (activity.type !== 'START') && (activity.type !== 'END')"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="account"
                    classSize="lg"
                    fill="#484848"
                    [ngbTooltip]="'Account' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-demand-account-link class="flex text-ellipsis"
                               [account]="{name: activity.accountName, id: activity.accountId}"
                               isAllowCopyButton="true">

      </app-demand-account-link>
    </div>

    <!--Address Row-->
    <div *ngIf="settings?.columns?.address && (activity.type !== 'START') && (activity.type !== 'END')"
         class="flex-100 layout-row layout-align-start-center info-row gap-5">
      <!--      <bringoz-icon iconName="location-pin-outline"-->
      <!--                    classSize="lg"-->
      <!--                    fill="#484848"-->
      <!--                    [fill]="activity.stopType === 'Pickup' ? '#FF9936' : (activity.stopType === 'Dropoff' ? '#2196F3': '#2EBDA4')"-->
      <!--                    [ngbTooltip]="'Address' | translate"-->
      <!--                    openDelay="300">-->

      <!--      </bringoz-icon>-->
      <app-task-purpose [purpose]="activity.stopType" firstLetterOnly="true"></app-task-purpose>
      <span class="br-body-1 text-ellipsis">{{ activity.address | bringozAddress }}</span>
    </div>

    <!--Time Window Row-->
    <div *ngIf="settings?.columns?.timeWindow && stopRef"
         class="flex-100 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="time-window-outline"
                    classSize="lg"
                    fill="#484848"
                    [ngbTooltip]="'Time Window' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1">{{ stopRef | timeWindow }}</span>
    </div>

    <!--Time Estimations Row-->
    <div *ngIf="settings?.columns?.timeEstimations"
         class="flex-100 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="timer-outline"
                    classSize="lg"
                    fill="#484848"
                    [ngbTooltip]="'ETA / ETD' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1">{{ activity | planningActivityTimeWindow }}</span>
    </div>

    <!--Service Time Row-->
    <div *ngIf="settings?.columns?.serviceTime && (activity.type !== 'START') && (activity.type !== 'END')"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="timer-outline"
                    classSize="lg"
                    fill="#484848"
                    [ngbTooltip]="'Service Time' | translate"
                    openDelay="300">

      </bringoz-icon>

      <span *ngIf="!activity.detailedServiceTime"
            class="br-body-1 text-ellipsis">{{ activity.serviceTime | bringozTimeConvert:true }}</span>

      <app-task-detailed-service-time *ngIf="!!activity.detailedServiceTime"
                                      [isAllowEdit]="false"
                                      [fontSize]="'br-body-1'"
                                      [ignorePackageServiceTime]="true"
                                      [detailedServiceTime]="activity.detailedServiceTime">
      </app-task-detailed-service-time>
    </div>


    <!--Service Time Row-->
    <div *ngIf="settings?.columns?.distance && (activity.type !== 'START') && (activity.type !== 'END')"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="distance"
                    classSize="lg"
                    fill="#484848"
                    [ngbTooltip]="'Distance From Last Stop' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span
        class="br-body-1 text-ellipsis">{{ activity.distanceFromLastStopMeter | bringozDistance: '---':true }}</span>
    </div>

    <!--Contacts Row-->
    <div *ngIf="settings?.columns?.contacts && (activity.type !== 'START') && (activity.type !== 'END')"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="contact-circle"
                    classSize="lg"
                    fill="#484848"
                    [ngbTooltip]="'Contacts' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ stopRef?.contact?.name || '---' }}</span>
    </div>

    <!--SLA Row-->
    <div *ngIf="settings?.columns?.sla && (activity.type !== 'START') && (activity.type !== 'END')"
         class="flex-50 layout-row info-row layout-align-start-center gap-5">
      <span class="br-body-1 fon-weight-600">SLA</span>
      <span class="br-body-1">{{ job | bringozDate: 'sla' }}</span>
      <span class="br-body-1">{{ job | bringozTime: 'sla' }}</span>
    </div>

    <!--Labels Row-->
    <div *ngIf="settings?.columns?.labels && (activity.type !== 'START') && (activity.type !== 'END')"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="label-outline"
                    classSize="lg"
                    fill="#484848"
                    [ngbTooltip]="'Labels' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-labels-display [labels]="labels"
                                  maxItems="1">

      </app-bringoz-labels-display>
      <span *ngIf="!labels?.length" class="br-body-1 text-ellipsis">---</span>
    </div>

    <!--Packages Row-->
    <div *ngIf="settings?.columns?.packages && (activity.type !== 'START') && (activity.type !== 'END')"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="package-outline"
                    classSize="lg"
                    fill="#484848"
                    [ngbTooltip]="'Packages' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-packages-items-display-list class="flex"
                                               [items]="job?.packages">

      </app-bringoz-packages-items-display-list>
    </div>

    <!--Barcodes Row-->
    <div *ngIf="settings?.columns?.barcodes && (activity.type !== 'START') && (activity.type !== 'END')"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="barcode"
                    classSize="lg"
                    fill="#484848"
                    [ngbTooltip]="'Barcodes' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-items-list-display [items]="barcodesList" maxItems="1"></app-bringoz-items-list-display>
    </div>

    <!--Recurring Service template ID-->
    <div
      *ngIf="!!job.serviceTemplateId && settings?.columns?.recurringServiceTemplateId && (activity.type !== 'START') && (activity.type !== 'END')"
      class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="recurring" class="gray-102" classSize="lg"></bringoz-icon>
      <app-bringoz-state-link class="text-ellipsis"
                              [state]="'recurring-services'"
                              [permission]="'recurring-service-template.list'"
                              [params]="{queryString: job.serviceTemplateId}"
                              [text]="job.serviceTemplateId">
      </app-bringoz-state-link>
    </div>

    <!--Load - Weight-->
    <div *ngIf="settings?.load?.weight && (activity.type !== 'START') && (activity.type !== 'END')"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="weight"
                    classSize="lg"
                    fill="#484848"
                    [ngbTooltip]="'Weight' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ activity.packages | planningPackagesWeightPipe:true }}</span>
    </div>

    <!--Load - Volume-->
    <div *ngIf="settings?.load?.volume && (activity.type !== 'START') && (activity.type !== 'END')"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="volume"
                    classSize="lg"
                    fill="#484848"
                    [ngbTooltip]="'Volume' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ activity.packages | planningPackagesVolumePipe: true }}</span>
    </div>

    <!--Load - Packages-->
    <div *ngIf="settings?.load?.packages && (activity.type !== 'START') && (activity.type !== 'END')"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="package-outline"
                    classSize="lg"
                    fill="#484848"
                    [ngbTooltip]="'Packages' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ activity.packages | planningPackagesPipe:false }}</span>
    </div>

    <!--Load - Value-->
    <div *ngIf="settings?.load?.value && (activity.type !== 'START') && (activity.type !== 'END')"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="dollar-circle"
                    classSize="lg"
                    fill="#484848"
                    [ngbTooltip]="'Value' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ job?.price | bringozPrice }}</span>
    </div>

    <!--Load - Pallets-->
    <div *ngIf="settings?.load?.pallets && (activity.type !== 'START') && (activity.type !== 'END')"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="pallets"
                    classSize="lg"
                    fill="#484848"
                    [ngbTooltip]="'Pallets' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ activity.packages | planningPackagesPalletsPipe: false }}</span>
    </div>

    <!--Load - Spots-->
    <div *ngIf="settings?.load?.spots && (activity.type !== 'START') && (activity.type !== 'END')"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="spot"
                    classSize="lg"
                    fill="#484848"
                    [ngbTooltip]="'Spots' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ activity.packages | planningPackagesSpotsPipe: true }}</span>
    </div>


    <!--    &lt;!&ndash;Capacity Row&ndash;&gt;-->
    <!--    <div *ngIf="settings?.capacity && capacity" class="flex-50 layout-row layout-align-start-center info-row gap-5">-->
    <!--      <bringoz-icon [iconName]="capacity.icon"-->
    <!--                    classSize="lg">-->

    <!--      </bringoz-icon>-->
    <!--      <app-bringoz-capacity-bar class="flex" [value]="capacity.percentage">-->

    <!--      </app-bringoz-capacity-bar>-->
    <!--      <span class="br-body-1">{{capacity.percentage}}%</span>-->
    <!--    </div>-->


  </div>

</div>
